import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translationsJobWorkflowClearState } from 'reducers/translations/jobWorkflow/reducer'
import JobWorkflowList from './JobWorkflowList'
import JobWorkflowItem from './JobWorkflowItem'

function JobWorkflow(props) {
  const {
    match: {
      params: { id },
    },
    translationsJobWorkflowClearState,
  } = props
  const JobWorkflowContent = id ? JobWorkflowItem : JobWorkflowList

  useEffect(
    () => () => {
      translationsJobWorkflowClearState()
    },
    [],
  )

  return (
    <div className="content">
      <JobWorkflowContent {...props} />
    </div>
  )
}

JobWorkflow.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  translationsJobWorkflowClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  translationsJobWorkflowClearState,
})(JobWorkflow)
